import React, { FC, useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import { isDesktop } from 'react-device-detect';
import Skeleton from 'react-loading-skeleton';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { BannerModel } from '../../types';
import styles from './PromoSlider.module.scss';
import usePromoSliderQuery from './usePromoSliderQuery';
import useWindowDimensions from 'hooks/useWindowDimensions';


const PromoSlider: FC<{ banners?: BannerModel[] }> = ({ banners: bannersData }) => {
  const { width } = useWindowDimensions();

  const { banners: _banners, isFetched } = usePromoSliderQuery(!(bannersData || [])?.length);
  const isBannersFetched = useMemo(() => !!(bannersData || [])?.length || isFetched, [bannersData, isFetched]);
  const isDesktopDevice = typeof window !== 'undefined' ? isDesktop : false;

  const banners = useMemo(() => bannersData || _banners || [], [_banners, bannersData]);

  const filteredData = useMemo(() => banners.filter((item: any) => {
    if (width && width < 580) return !!item?.images?.mobile;
    if (width && width > 580) return !!item?.images?.original;
    return true;
  }), [banners, width]);

  if (!isBannersFetched || !banners?.length) return <Skeleton count={1} height={200} />;

  return (
    <div className={`${isDesktopDevice ? 'promo-slider' : ''}`}>
      {filteredData.length ? (<Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
        navigation={isDesktopDevice}
        loop={true}
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        speed={900}
      >
          {filteredData.map((banner: any) => {
            return (
              <SwiperSlide key={banner.id}>
                <a href={banner.url} target={banner.new_tab ? '_blank' : ''} rel="noreferrer noopener">
                  <div className="movie-poster-item cursor-pointer overflow-hidden">
                    <picture>
                      <LazyLoadImage loading={'lazy'} className={styles.imageDesktop} src={banner?.images?.original}
                                     alt={banner?.description || 'banner poster'} />
                      {banner?.images?.mobile && (
                        <LazyLoadImage loading={'lazy'} className={styles.imageMobile} src={banner?.images?.mobile}
                                       alt={banner?.description || 'banner poster'} />
                      )}
                    </picture>
                  </div>
                </a>
              </SwiperSlide>
            );
          })}
        </Swiper>)
        : <Skeleton count={1} height={200} />}
    </div>
  );
};

export default PromoSlider;
